export default "__VITE_ASSET__C7SA0D9D__"